import { router } from 'expo-router';
import * as React from 'react';
import { Pressable } from 'react-native';
import {
    BodyMediumEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    SafeAreaView,
    ToastViewport,
    YStack,
} from 'smoothie';

interface PopUpReceiptProps {
    title?: string;
    children: React.ReactNode;
    additionalButtons?: React.ReactElement[];
    onClose?: () => void;
    showTitle?: boolean;
    showButtons?: boolean;
}

/**
 * This component needs to be paired with the following stack presentation:
 *  <Stack.Screen
 *      options={{
 *          presentation: 'transparentModal',
 *          animation: 'fade',
 *          contentStyle: {
 *              backgroundColor: 'transparent',
 *          },
 *      }}
 *  />
 */
const PopUpReceipt = ({
    title,
    children,
    additionalButtons,
    onClose,
    showButtons = true,
}: PopUpReceiptProps) => {
    return (
        <Pressable
            onPress={router.back}
            style={{
                flex: 1,
                backgroundColor: 'rgba(0,0,0,0.5)',
            }}
        >
            <SafeAreaView style={{ flex: 1 }}>
                <ToastViewport
                    flexDirection="column"
                    bottom={120}
                    left={0}
                    right={0}
                />
                <YStack
                    marginHorizontal={16}
                    marginTop="auto"
                    gap={8}
                    onPress={(e) => {
                        e.stopPropagation();
                    }}
                    $sm={{
                        width: 500,
                        marginBottom: 'auto',
                        alignSelf: 'center',
                    }}
                >
                    <YStack
                        borderRadius={30}
                        backgroundColor="$white"
                        marginTop="auto"
                        paddingHorizontal={16}
                        paddingVertical={24}
                        gap={24}
                    >
                        {title != null && (
                            <BodyMediumEmphasized textAlign="center">
                                {title}
                            </BodyMediumEmphasized>
                        )}
                        {children}
                    </YStack>
                    {additionalButtons}

                    {showButtons && (
                        <Button
                            variant={ButtonVariant.PRIMARY}
                            size={ButtonSize.LARGE}
                            text="Close"
                            onPress={() => {
                                onClose ? onClose() : router.back();
                            }}
                        />
                    )}
                </YStack>
            </SafeAreaView>
        </Pressable>
    );
};

export default PopUpReceipt;
